import React from 'react';
import { registry } from '../../core/Registry.js';
import { BaseWidget } from '../BaseWidget.jsx';

export function MapRender({ node, isLiveMode }) {
  const content = node.content || {};
  
  const address = content.address || 'Georg-Brauchle-Ring 50, München, Telefónica';
  const zoom = content.zoom || '14';
  const height = content.height || '400px';
  const filter = content.filter || 'grayscale(80%) invert(90%) contrast(80%)'; // Dark Mode Effect für TEF
  
  // Im Live-Modus zeigen wir die Map, im Editor oft lieber einen Placeholder (Performance & Dragging)
  // Wir zeigen trotzdem das iFrame, aber blockieren Input
  
  const encodedAddress = encodeURIComponent(address);
  const iframeSrc = `https://maps.google.com/maps?q=${encodedAddress}&t=&z=${zoom}&ie=UTF8&iwloc=&output=embed`;

  return (
    <div style={{
      width: '100%',
      height: height,
      position: 'relative',
      borderRadius: '16px',
      overflow: 'hidden',
      pointerEvents: !isLiveMode ? 'none' : 'auto' // Im Editor blockieren
    }}>
      <iframe 
        width="100%" 
        height="100%" 
        frameBorder="0" 
        scrolling="no" 
        marginHeight="0" 
        marginWidth="0" 
        src={iframeSrc}
        style={{
          filter: filter // Für den typischen Dark-Mode Look
        }}
        title="Google Map"
      />
    </div>
  );
}

registry.register('Map', {
  label: 'Google Maps Karte',
  icon: '🗺️', 
  category: 'media',
  component: MapRender,
  
  defaultProps: {
    content: {
      address: 'Georg-Brauchle-Ring 50, München',
      zoom: '14',
      height: '350px',
      filter: 'grayscale(80%) invert(90%) contrast(80%)'
    },
    style: {
      desktop: {
        marginBottom: '20px'
      }
    }
  },

  inspectorControls: [
    {
      tab: 'content',
      groups: [
        {
          title: 'Google Maps API (iframe)',
          fields: [
            { name: 'content.address', label: 'Adresse / Suchbegriff', type: 'text' },
            { name: 'content.zoom', label: 'Zoom-Level (1-20)', type: 'select', options: ['10', '12', '14', '16', '18'] }
          ]
        },
        {
          title: 'Darstellung',
          fields: [
            { name: 'content.height', label: 'Höhe (z.B. 400px)', type: 'text' },
            { name: 'content.filter', label: 'CSS Map Filter (Darkmode by default)', type: 'text' }
          ]
        }
      ]
    }
  ]
});
